// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesStyles } from "@keller/Overrides/Widgets/Cart/CartLines";
import { css } from "styled-components";

cartLinesStyles.cartLineActionsWrapper = {
    css: css`
        display: flex;
        flex-grow: 1;
        align-items: flex-end;
        justify-content: space-between;
        width: 100%;
    `,
};
